export const elmAppId = 'elm-app'
